<template>
  <breadCrumbs title="General" main="Widgets" title1="general" />
  <div class="container-fluid general-widget">
    <div class="row">
      <cardsPage />
      <gsalesPage />
      <orderPage />
      <clockPage />
      <datePicker />
      <feedbackPage />
      <mangerPage />
      <recentactivityPage />
      <newPage />
      <browserPage />
      <socialPage />
      <productPage />
      <employeePage />
      <div class="col-sm-12 col-lg-6 col-xl-4 col-md-12 box-col-6 xl-50">
        <div class="card height-equal">
          <div class="calender-widget">
            <div class="cal-img"></div>
            <div class="cal-date">
              <h5>25<br>APRIL</h5>
            </div>
            <div class="cal-desc text-center card-body">
              <h3>I must explain to you how? </h3>
              <p>We are excited about continuing to build a complete ecosystem around value commerce, where we can serve
                Bharat consumers wherever they are on their shopping journey. Our mission is to become India’s value
                lifestyle omni-channel leader.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-lg-6 col-xl-8 col-md-12 box-col-6 xl-50">
        <div class="card general-contact">
          <div class="card-header">
            <h3>Contact Us</h3>
          </div>
          <div class="contact-form card-body">
            <form class="theme-form">
              <div class="form-icon"><i class="icofont icofont-envelope-open"></i></div>
              <div class="mb-3">
                <label for="exampleInputName">Your Name</label>
                <input class="form-control" id="exampleInputName" type="text" placeholder="John Dio">
              </div>
              <div class="mb-3">
                <label class="col-form-label" for="exampleInputEmail1">Email</label>
                <input class="form-control" id="exampleInputEmail1" type="email" placeholder="Demo@gmail.com">
              </div>
              <div class="mb-3">
                <label class="col-form-label" for="exampleInputEmail1">Message</label>
                <textarea class="form-control textarea" rows="3" cols="50" placeholder="Your Message"></textarea>
              </div>
              <div class="text-sm-end"><router-link class="btn btn-primary" to="/email/readMail">SEND IT</router-link>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

import cardsPage from '../general/cardsPage.vue'
import gsalesPage from '../general/gsalesPage.vue'
import orderPage from '../general/orderPage.vue'
import clockPage from '../general/clockPage.vue'
import datePicker from '../general/datePicker.vue'
import feedbackPage from '../general/feedbackPage.vue'
import mangerPage from '../general/mangerPage.vue'
import recentactivityPage from '../general/recentactivityPage.vue'
import newPage from '../general/newPage.vue'
import browserPage from '../general/browserPage.vue'
import socialPage from '../general/socialPage.vue'
import productPage from '../general/productPage.vue'
import employeePage from '../general/employeePage.vue'
export default {
  name: 'indexGeneral',
  components: {
    cardsPage,
    gsalesPage,
    orderPage,
    clockPage, datePicker, feedbackPage,
    mangerPage, recentactivityPage, newPage,
    browserPage, socialPage, productPage, employeePage
  }
}
</script>